export default {

  'admin': {
    'role': 'admin'
  },
  'agent' :{
    'role': 'agent'
  }
}
